/* istanbul ignore file - No need to test Slick */

/**
 * Provides JS functionality for tracking alert display.
 */
class Testimonials extends DrupalBehavior {
  onContent(context) {
    let slickOptions = {
      dots: false,
      slidesToShow: 1,
      speed: 750,
      draggable: true,
      fade: false,
      arrows: true,
      adaptiveHeight: true,
      appendArrows: $('.testimonials-arrows .container', context),
    };

    var $slider = $('.testimonials--inner', context);

    // Initializes the slick slider.
    $slider.slick(slickOptions);
  }
}

DrupalBehavior.register('rush_theme.components', 'testimonials', Testimonials);
